(function () {
  function initBenefitSections() {
    var sections = document.querySelectorAll('.premium-image-benefits');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var items = section.querySelectorAll('.premium-image-benefits-item');
      items.forEach(function (item, index) {
        item.style.transitionDelay = index * 0.08 + 's';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBenefitSections);
  } else {
    initBenefitSections();
  }

  document.addEventListener('shopify:section:load', initBenefitSections);
})();
